import React from "react";
import NavBar from "../header/NarBar";
import MainSidebar from "../sidebar/MainSidebar";
import { useLayoutSidebarStore } from "../../store/layout/useLayoutSidebarStore";

interface InternalLayoutProps {
  children: React.ReactNode;
}

const InternalLayout: React.FC<InternalLayoutProps> = ({ children }) => {
  const { sidebarOpen, toggleSidebar } = useLayoutSidebarStore();

  return (
    <div className="bg-main min-h-screen overflow-x-hidden">
      <NavBar sidebarOpen={sidebarOpen} setSidebarOpen={toggleSidebar} />
      <div className="flex">
        <MainSidebar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={toggleSidebar}
        />
        <div className="flex-1 p-4 overflow-x-hidden">
          {children}
        </div>
      </div>
    </div>
  );
};

export default InternalLayout;
